// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"5b8d0619","493":"5b8d0619","504":"5b8d0619","524":"86bc0cdb","577":"90f9bf71","721":"5b8d0619","744":"5b8d0619","836":"5b8d0619","848":"5b8d0619","952":"5b8d0619"}[chunkId] + ".chunk.css";
};